export default () => {
  return {
    clinicTreatmentAreas: [],
  };
};
